import React, { FC } from 'react';
import styles from './Checkbox.module.css';
import { Typography, TypographyTagVariants } from '../Typography';

export enum CheckboxType {
    normal = 'normal',
    blackVariant = 'blackVariant',
}

export interface CheckboxProps {
    id?: string;
    classes?: string;
    type: CheckboxType;
    name: string;
    value: string;
    label: string | JSX.Element;
    disabled?: boolean;
    required?: boolean;
    checked?: boolean;
    onChange?: (value: string) => void;
}

export const Checkbox: FC<CheckboxProps> = ({ id, classes, type, name, value, label, disabled, required, checked, onChange }) => {
    return (
        <div className="form-check">
            <input
                className={`form-check-input ${styles['form-check-input']} ${type === 'blackVariant' ? styles['black-checkbox'] : ''} ${classes || ''}`}
                type="checkbox"
                name={name}
                value={value}
                disabled={disabled}
                required={required}
                checked={checked}
                id={id || ''}
                onChange={(value) => onChange && onChange(value.target.value)}
            />
            <Typography tagVariant={TypographyTagVariants.span}>
                <label className="form-check-label">{label}</label>
            </Typography>
        </div>
    );
};
